import React, { createContext, useContext, useCallback } from 'react';
import translations from '../i18n/translations';

// Multi-language was removed — the app and landing page are English-only.
// This stub keeps existing useLanguage() / t() consumers working without a
// rewrite: t(key) returns the English string (or the key as a fallback),
// language is the constant 'en', and setLanguage is a no-op.
const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const t = useCallback((key, params) => {
    let str = (translations.en && translations.en[key]) || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        str = str.replace(`{${k}}`, v);
      });
    }
    return str;
  }, []);

  return (
    <LanguageContext.Provider value={{ language: 'en', setLanguage: () => {}, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { language: 'en', setLanguage: () => {}, t: (key) => key };
  return ctx;
}
